import React, { useState, useEffect } from "react";
import { Typography, Box, Divider, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import dayjs from "dayjs";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";

import PersonIcon from "@mui/icons-material/Person";
import GroupsIcon from "@mui/icons-material/Groups";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import "./child.css";
import { fetchPriceByCalendar } from "../Services/Organisation.service";
import CountdownTimer from "./countDown";
import { useTranslation } from "react-i18next";
import LibraTranslate from "../LibreTransalate";
import moment from "moment";

interface BookingSummaryProps {
  activeStep: number;
  title: string;
  data: any;
  calendarObject: any;
  setFieldValue: Function
}

interface BookingMemberType {
  bookingmembertypeid: string;
  bookingbusinessrule: string;
  unitprice: number;
  bookingmembertype: string;
  
  // Add other properties if necessary
}

const BookingSummary: React.FC<BookingSummaryProps> = ({ activeStep, title, data, calendarObject, setFieldValue }) => {
  const [showMore, setShowMore] = useState(false);
  const [sum, setSum] = useState(0);
  const [totalTickets, setTotalTickets] = useState(0);
  const [initValue, setInitVal] = useState<BookingMemberType[]>([]);
  const [addonsPrice, setAddonsPrice] = useState<any>([]);
  const { t } = useTranslation();
  useEffect(() => {
    if (calendarObject?.calendarid) {
      fetchBookingMemberTypes();
    }
  }, []);

  const isPercentageMapper: any = {
    true: "Percentage",
    false: "Fixed",
  };

  const fetchBookingMemberTypes = async () => {
    try {
      const response = await fetchPriceByCalendar(calendarObject?.calendarid);
      if (response) {
        setInitVal(response?.price);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if ( !data?.promoCodeValue && data && data?.addons && data?.addons.length > 0) {
      fetchAddonsData(data.addons);
    }
  }, [data?.addons]);

  console.log("zasasssas")
  const fetchAddonsData = async (addons: any[]) => {
    try {
      const addonsPrice: any[] = [];
      for (let i = 0; i < addons?.length; i++) {
        const addonPrice = await fetchPriceByCalendar(addons[i].calendarid);
        const addonsPriceObject: any = {
          calendarid: addons[i].calendarid,
          prices: addonPrice?.price,
        };
        addonsPrice.push(addonsPriceObject);
      }
      setAddonsPrice(addonsPrice);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    let totalBillings = 0;
    let totalTickets = 0;
  
    if (data.bookingMemberTypes) {
      Object.keys(data.bookingMemberTypes).forEach((bookingData) => {
        const rowData = initValue.find((item) => item.bookingmembertypeid === bookingData);
        const bookingCount = data.bookingMemberTypes[bookingData];
        totalTickets += bookingCount;
  
        if (
          data.promoCodeValue?.promoCode?.once_per_ticket &&
          isPercentageMapper[data.promoCodeValue.promoCode.is_percentage] === "Fixed"
        ) {
          totalBillings += bookingCount > 0 && rowData
            ? bookingCount * rowData.unitprice - bookingCount * parseInt(data.promoCodeValue.promoCode.value)
            : 0;
        } else {
          totalBillings += bookingCount > 0 && rowData ? bookingCount * rowData.unitprice : 0;
        }
      });
    }
  
    if (data.addons && addonsPrice && addonsPrice.length > 0) {
      for (let i = 0; i < data.addons.length; i++) {
        const bookingMemberTypes = data.addons[i]?.bookingMemberTypes;
        if (bookingMemberTypes) {
          Object.keys(bookingMemberTypes).forEach((bookingData) => {
            const rowData = addonsPrice
              .find((addon: any) => addon.calendarid === data.addons[i]?.calendarid)
              ?.prices?.find((item: any) => item.bookingmembertypeid === bookingData);
            const bookingCount = bookingMemberTypes[bookingData];
            totalTickets += bookingCount;
  
            if (
              data.promoCodeValue?.promoCode?.once_per_ticket &&
              isPercentageMapper[data.promoCodeValue.promoCode.is_percentage] === "Fixed"
            ) {
              totalBillings += bookingCount > 0 && rowData
                ? bookingCount * rowData.unitprice - parseInt(data.promoCodeValue.promoCode.value)
                : 0;
            } else {
              totalBillings += bookingCount > 0 && rowData ? bookingCount * rowData.unitprice : 0;
            }
          });
        }
      }
    }
  
    if (data.promoCodeValue?.promoCode) {
      if (isPercentageMapper[data.promoCodeValue.promoCode.is_percentage] === "Percentage") {
        totalBillings -= (totalBillings * parseInt(data.promoCodeValue.promoCode.value)) / 100;
      } else if (data.promoCodeValue.promoCode.once_per_purchase &&
                 isPercentageMapper[data.promoCodeValue.promoCode.is_percentage] === "Fixed") {
        totalBillings -= parseInt(data.promoCodeValue.promoCode.value);
      }
    }
  
    // 🔥 Now call setFieldValue/setSum/setTotalTickets ONLY ONCE at the END
    setFieldValue(
      data.promoCodeValue?.promoCode ? "TOTALAMOUNTWITHTDISCOUNT" : "TOTALAMOUNTWITHOUTDISCOUNT",
      totalBillings
    );
    setSum(totalBillings);
    setTotalTickets(totalTickets);
    
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(data.bookingMemberTypes), JSON.stringify(data.addons), JSON.stringify(initValue), JSON.stringify(addonsPrice), JSON.stringify(data.promoCodeValue)]);
  

  

  const accordionData = calendarObject?.description ?? t("paregrah");
  return (
    <div>
      <Box sx={{minHeight: "4rem"}} display={"flex"} alignItems={"center"}>
        {
          activeStep == 3 && <Typography variant="h4">{calendarObject?.calendarname }</Typography>
        }
      </Box>
      <div className="ticketWrapperSummary">
        <div className="white_box">
          <Box display={"flex"} justifyContent={"space-between"} width={"100%"} alignItems={"baseline"}>
            <Box display={"flex"} flexDirection={"column"} rowGap={"0.5rem"} width={"60%"}>
              <h4 className="ticket-summary-heading">Payment Details</h4>
              <p className="ticket-summary-total-tickets">Total Tickets: {totalTickets}</p>
            </Box>
            {activeStep === 3 && (
              <Box display={"flex"} flexDirection={"column"} justifyContent={"flex-end"} width={"40%"}>
                <Typography variant="body2">
                  <CountdownTimer initialMinutes={8} initialSeconds={0} />
                </Typography>

                <Typography style={{ fontSize: "10px", opacity: "0.8" }}>
                  {t("minutes to secure your booking")}
                </Typography>

              </Box>
            )}
          </Box>

          {activeStep !== 3 ? (
            <>
              <span className="activity-description">{showMore == true ? <LibraTranslate lang={"en"} text={accordionData as string} /> : <LibraTranslate lang={"en"} text={accordionData.substring(0, 150) as string} />}</span>
              <span className="read-more-btn" onClick={() => setShowMore(!showMore)}>
                {""}  {showMore ? t("Show less") : t("Show more")}
              </span>
            </>
          ) : (
            <Box display={"flex"} flexDirection={"column"} rowGap={"0.5rem"} mt={"1.2rem"}>
              <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} rowGap={"0.4rem"}>
                <Typography variant="body2" fontWeight={600} fontSize={14}>Full Name</Typography>
                <Typography variant="body2" fontWeight={500} fontSize={14}>{data.firstName} {data.lastName}</Typography>
              </Box>
              <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} rowGap={"0.4rem"}>
                <Typography variant="body2" fontWeight={600} fontSize={14} sx={{ display: "flex", alignItems: "center" }} > Email</Typography>
                <Typography variant="body2" fontWeight={500} fontSize={14}>{data.email} </Typography>
              </Box>
              <Box display={"flex"} flexDirection={"row"} justifyContent={"space-between"} rowGap={"0.4rem"}>
                <Typography variant="body2" fontWeight={600} fontSize={14} sx={{ display: "flex", alignItems: "center" }} > Phone Number</Typography>
                <Typography variant="body2" fontWeight={500} fontSize={14}>{data.phoneNumber} </Typography>
              </Box>
            </Box>
          )}
        </div>
        <Box display={"flex"} justifyContent={"space-between"} mt={"1rem"} mb={"0.8rem"}>
          <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} rowGap={"0.4rem"}>
            <Typography variant="caption">Valid On</Typography>
            <Typography variant="body2" fontWeight={600} fontSize={14}>{dayjs(data?.desiredDate).format("ddd DD MMM YYYY")}</Typography>
          </Box>
          <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} rowGap={"0.4rem"} alignItems={"flex-end"}>
            <Typography variant="caption">Time Slot</Typography>
            <Typography variant="body2" fontWeight={600} fontSize={14}>{moment(data?.desiredTime).utc().format("hh:mm A")} - {data?.desiredEndTime}</Typography>
          </Box>
        </Box>
        <Box display={"flex"} flexDirection={"column"}>
          {data.bookingMemberTypes &&
            Object.entries(data.bookingMemberTypes).map(
              ([bookingId, bookingCount]: any) => {
                const rowData = initValue.find(
                  (data) => data.bookingmembertypeid === bookingId
                );
                if (!bookingCount) return null;
                const IconComponent = bookingCount > 1 ? GroupsIcon : PersonIcon;
                let mainAmount = 0;
                mainAmount +=
                  bookingCount > 0 && rowData ? bookingCount * rowData?.unitprice : 0;
                return (
                  <Box display={"flex"} justifyContent={"space-between"} mb={"0.8rem"}>
                    <Typography
                      key={bookingId}
                      variant="body2"

                      fontSize={14}
                      fontWeight={500}
                      sx={{ color: 'rgb(0, 0, 0)', display: "flex", flexDirection: 'column', width: "50%" }}
                    >
                      {rowData?.bookingmembertype} x {bookingCount} (${rowData?.unitprice} per ticket)<br />
                      <Typography variant="caption" fontSize={12} fontWeight={400} sx={{ opacity: "0.5" }}>{rowData?.bookingbusinessrule}</Typography>
                    </Typography>
                    <Typography
                      key={bookingId}
                      variant="body2"

                      fontWeight={500}
                      fontSize={14}
                      sx={{ color: 'rgb(0, 0, 0)' }}
                    >
                      ${mainAmount}
                    </Typography>
                  </Box>

                );
              }
            )}
        </Box>

        {data?.addons?.length > 0 &&
          data?.addons?.map((addon: any, index: number) => {
            return (
              <React.Fragment key={`addon-section-${index}`}>
                <div>
                  <Divider />
                  <div>
                    <Typography fontSize={14} fontWeight={500} mt={"0.4rem"} sx={{ textDecoration: "underline" }}>
                      {addon?.calendarname.length > 0 && addon?.calendarname}
                    </Typography>
                    {addon.desireddate &&
                      <Box display={"flex"} justifyContent={"space-between"} mt={"0.3rem"} mb={"0.3rem"}>
                        <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} rowGap={"0.4rem"}>
                          <Typography variant="caption">Valid On</Typography>
                          <Typography variant="body2" fontWeight={600} fontSize={14}>{dayjs(addon.desireddate).format("ddd DD MMM YYYY")}</Typography>
                        </Box>
                        <Box display={"flex"} flexDirection={"column"} justifyContent={"space-between"} rowGap={"0.4rem"}>
                          <Typography variant="caption">Time Slot</Typography>
                          <Typography variant="body2" fontWeight={600} fontSize={14}>{moment(addon.desiredtime).utc().format("hh:mm A")}</Typography>
                        </Box>
                      </Box>
                    }
                    <Box className={'userInfo'}>
                      {addon.bookingMemberTypes &&
                        Object.entries(addon.bookingMemberTypes).map(
                          ([bookingId, bookingCount]: any) => {
                            const rowData = addonsPrice
                              .find((addonobj: any) => addonobj.calendarid === addon?.calendarid)
                              ?.prices?.find((data: any) => data.bookingmembertypeid === bookingId);
                            if (!bookingCount) return null;
                            const IconComponent = bookingCount > 1 ? GroupsIcon : PersonIcon;
                            let addonsTotal = 0;
                            addonsTotal +=
                              bookingCount > 0 && rowData ? bookingCount * rowData?.unitprice : 0;

                            return (
                              <Box display={"flex"} justifyContent={"space-between"} mb={"0.8rem"} padding={"0rem 0.675rem"}>
                                <Typography
                                  key={bookingId}
                                  variant="body2"

                                  fontSize={14}
                                  fontWeight={500}
                                  sx={{ color: 'rgb(0, 0, 0)', display: "flex", flexDirection: 'column', width: "50%" }}
                                >
                                  {rowData?.bookingmembertype} x {bookingCount} (${rowData?.unitprice} per ticket)<br />
                                  <Typography variant="caption" fontSize={12} fontWeight={400} sx={{ opacity: "0.5" }}>{rowData?.bookingbusinessrule}</Typography>
                                </Typography>
                                <Typography
                                  key={bookingId}
                                  variant="body2"

                                  fontWeight={500}
                                  fontSize={14}
                                  sx={{ color: 'rgb(0, 0, 0)' }}
                                >
                                  ${addonsTotal}
                                </Typography>
                              </Box>
                            );
                          }
                        )}
                    </Box>
                  </div>
                </div>
              </React.Fragment>
            );
          })}
        <Divider />
        <Box display={"flex"} justifyContent={"space-between"} mt={"0.5rem"}>
          <Typography fontWeight={600} fontSize={16}>{ activeStep !== 3 ? 'Payable' : 'Paid'} Amount</Typography>
          <Typography fontWeight={600} fontSize={16}>${sum}</Typography>
        </Box>
        <Typography variant="caption" fontSize={14}>
          This amount includes all the taxes and charges.
        </Typography>
      </div>
    </div>
  );
};

export default React.memo(BookingSummary);
